import React, { useState, useEffect } from "react";
// import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useHistory } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";

function BankManagement() {
    const [group, setGroup] = useState([]);
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [selectedCustomers, setSelectedCustomers] = useState(null);
    const [displaySubDetailsModal, setDisplaySubDetailsModal] = useState(false);
    const [status, setstatus] = useState(false);
    const [authDetailId, setAuthDetailId] = useState([]);
    const [transHeadId, setTransHeadId] = useState([]);
    const [checked2, setChecked2] = useState(true);
    const [editable, setEditable] = useState(false);

    // useEffect(() => {
    //     const getGroup = async () => {
    //         setloading(true);
    //         // const response = await handleGetRequest("zbiz/fin/branchAuth/fetchAllPendingAuthTransactions");
    //         setGroup(response?.data);
    //         setloading(false);
    //     };
    //     getGroup();
    // }, []);

    let history = useHistory();

    const myData = [
        {
            bankCode: 1,
            bankName: "Js Bank Limited",
        },
        {
            bankCode: 2,
            bankName: "NIB",
        },
    ];

    const handleAddNewSubDetails = (e, btnStatus) => {
        e.preventDefault();
        setstatus(btnStatus);
        setDisplaySubDetailsModal(true);
    };

    const onRowSelect = (event) => {
        setAuthDetailId(event.data.authDetailId);
        setTransHeadId(event.data.transHeadId);
    };

    const onHide = (name) => {
        setDisplaySubDetailsModal(false);
    };

    const switchTemplate = () => {
        return <InputSwitch checked={checked2} onChange={(e) => setChecked2(e.value)} />;
    };
    const updateClicked = (e) => {
        setEditable(true);
        history.push(`/addbankmanagement?editable=true`);
    };
    const actionTemplate = () => {
        return (
            <div>
                <i className="pi pi-tag" onClick={updateClicked}></i>
                <i className="pi pi-trash"></i>
            </div>
        );
    };

    // const removeTemplate = () => {
    //     return <i className="pi pi-times" style={{ fontSize: "2em" }}></i>;
    // };

    const handledClicked = () => {
        history.push("/addbankmanagement");
    };

    return (
        <>
            <div className="Top__Btn">
                <Button disabled={loading} onClick={handledClicked} label="Add Bank" className="Btn__Dark" />
            </div>
            <div className="card p-datatable-sm">
                <DataTable header="Bank List" value={myData} loading={loading} selection={selectedCustomers} onSelectionChange={(e) => setSelectedCustomers(e.value)} onRowSelect={onRowSelect} paginator rows={6} emptyMessage="No data found.">
                    <Column selectionMode="multiple" header="Select" headerStyle={{ width: "3em" }}></Column>
                    <Column filter field="bankCode" header="Bank Code" />
                    <Column filter field="bankName" header="Bank Name" />
                    <Column body={switchTemplate} header="Active" />
                    <Column body={switchTemplate} header="Approve" />
                    <Column body={actionTemplate} header="Action" />
                    {/* <Column body={removeTemplate} header="Delete" /> */}
                </DataTable>
            </div>
            <div className="Down__Btn">
                <Button label="Delete" onClick={(e) => handleAddNewSubDetails(e, "R")} className="Btn__Transparent" />
                <Button disabled={loading} onClick={(e) => handleAddNewSubDetails(e, "A")} label="Approve" className="Btn__Dark" />
            </div>
        </>
    );
}

export default BankManagement;
